import { useCallback, useState } from 'react';
import { DEPARTING, NEXT, RETURNING } from './constants';
import moment from '@g4/moment-utc';

const useListView = (
  tabDates,
  setDepartingTabs,
  setReturningTabs,
  setDepartingFlightOption,
  setReturningFlightOption,
  setIsArrowClicked,
  selectedFlightOptions
) => {
  // flag to signal whether the List View (FlightChooser) should auto-select the cheapest flight
  const [shouldAutoSelect, setShouldAutoSelect] = useState({
    [DEPARTING]: !selectedFlightOptions[DEPARTING],
    [RETURNING]: !selectedFlightOptions[RETURNING],
  });

  const handleArrowClick = useCallback(
    (leg, direction) => {
      setIsArrowClicked(true);
      setShouldAutoSelect(prevSate => ({ ...prevSate, [leg]: false }));
      const currentMiddleMoment = moment(tabDates[leg].middle);
      let newMiddleDate;
      if (direction === NEXT) {
        newMiddleDate = currentMiddleMoment.add(7, 'days').format('YYYY-MM-DD');
      } else {
        newMiddleDate = currentMiddleMoment
          .subtract(7, 'days')
          .format('YYYY-MM-DD');
      }
      if (leg === DEPARTING) {
        setDepartingFlightOption(null);
        setDepartingTabs({ middle: newMiddleDate, selected: newMiddleDate });
      } else {
        const minReturningDate = moment(tabDates[DEPARTING].selected)
          .add(1, 'days')
          .format('YYYY-MM-DD');
        const safeReturningDate = moment(newMiddleDate, 'YYYY-MM-DD').isBefore(
          moment(minReturningDate, 'YYYY-MM-DD')
        )
          ? minReturningDate
          : newMiddleDate;

        setReturningFlightOption(null);
        setReturningTabs({
          middle: safeReturningDate,
          selected: safeReturningDate,
        });
      }
    },
    [
      setShouldAutoSelect,
      setDepartingTabs,
      setReturningTabs,
      setDepartingFlightOption,
      setReturningFlightOption,
      tabDates,
      setIsArrowClicked,
    ]
  );

  return {
    shouldAutoSelect,
    setShouldAutoSelect,
    handleArrowClick,
  };
};

export default useListView;
